import { useDispatch } from "react-redux";
import { restApi } from "@/store/rest_api";
import type { AppDispatch } from "@/store/store";
import { useSocketSubscription } from "@/hooks/useSocketSubscription";
import { useSocketResync } from "@/hooks/useSocketResync";

export interface NewMessageEvent {
  conversationId: string;
  messageId: string;
  direction: string;
  fromNumber: string;
  body?: string;
  preview?: string;
  unreadCount: number;
}

export function useMessageSocket() {
  const dispatch = useDispatch<AppDispatch>();

  const invalidateMessageData = () => {
    dispatch(restApi.util.invalidateTags(["Conversations", "Messages", "CommunicationItems", "DncEntries"]));
  };

  useSocketSubscription("/user/queue/messages", invalidateMessageData);

  useSocketResync((resync) => {
    if (!resync.fullRefresh) {
      invalidateMessageData();
    }
  });
}
